import { queryTypes } from "next-usequerystate";
import { ChartTypeDefinitions, getDateFilterDefinitions } from "../definitions";
const datePresetSerializer = {
    parse: (value)=>{
        const datePreset = getDateFilterDefinitions().find((filter)=>filter.preset === value);
        if (datePreset) {
            return datePreset.preset;
        }
        return "last_7_days";
    },
    serialize: (value)=>value
};
const dimensionSerializer = {
    parse: (value)=>{
        if (ChartTypeDefinitions.some((chart)=>chart.dateDimension === value)) {
            return value;
        }
        return "purchaseDate";
    },
    serialize: (value)=>value
};
export const createChartFilterDefinitions = ({ defaults })=>{
    return {
        // Breakdown
        b: queryTypes.string,
        // (Date) Dimension
        dD: {
            ...dimensionSerializer,
            defaultValue: "purchaseDate"
        },
        // Date Interval
        dI: queryTypes.string.withDefault("auto"),
        // Date Preset
        dP: {
            ...datePresetSerializer,
            defaultValue: "last_30_days"
        },
        // Date From
        dF: queryTypes.string,
        // Date To
        dT: queryTypes.string,
        // Application ID
        // aId: queryTypes.array(queryTypes.integer).withDefault(defaults.applicationId),
        // Country Code
        cC: queryTypes.array(queryTypes.string),
        // Region
        r: queryTypes.array(queryTypes.string),
        // Placement
        p: queryTypes.array(queryTypes.string),
        // Product ID
        pId: queryTypes.array(queryTypes.string),
        // Variant ID
        vId: queryTypes.array(queryTypes.integer),
        // Paywall ID
        pWId: queryTypes.array(queryTypes.string),
        // Experiment ID
        eId: queryTypes.array(queryTypes.integer),
        // Campaign ID
        cId: queryTypes.array(queryTypes.string),
        // Audience ID
        aDId: queryTypes.array(queryTypes.integer),
        // Environment
        e: queryTypes.array(queryTypes.string).withDefault([
            "PRODUCTION"
        ]),
        // Store
        s: queryTypes.array(queryTypes.string),
        // App Version
        aV: queryTypes.array(queryTypes.string),
        // SDK Version
        sV: queryTypes.array(queryTypes.string),
        // Product Duration
        pD: queryTypes.array(queryTypes.string),
        // Revenue Types
        rT: queryTypes.array(queryTypes.string),
        // Event Types
        eT: queryTypes.array(queryTypes.string),
        // Sub Start Type
        sST: queryTypes.array(queryTypes.string),
        // Revenue Source
        rS: queryTypes.array(queryTypes.string)
    };
};
